import React from 'react';
const allComsosModules = require('../../cosmos/web-scoped/react');

function Icon({ name, cosmosIcon, color= '#ffffff', width= '18px', height= '18px', onClick, className= '' }) {
    const getIcon = (key, props) => {
        const Tag = allComsosModules[key];
        return (<Tag {...props} />)
    }
    if (cosmosIcon) {
        return (
            <>
                {getIcon(cosmosIcon, {
                    class: className,
                    'aria-label': `icon ${cosmosIcon}`,
                    onClick: onClick
                })}
            </>
        )
    } else {
        return (
            <>
                <span
                    className={`icon ${className}`}
                    onClick={onClick}
                    style={{
                        backgroundColor: color,
                        width: width,
                        height: height,
                        maskImage: `url("${name}")`,
                        WebkitMaskImage: `url("${name}")`,
                        maskSize: 'contain',
                        WebkitMaskSize: 'contain',
                        maskPosition: 'center',
                        WebkitMaskPosition: 'center',
                        maskRepeat: 'no-repeat',
                        WebkitMaskRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        display: 'inline-block',
                    }} />
            </>
        )
    }
}

export { Icon };
